import Vue from 'vue'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import './styles/index.scss'
import './styles/common.styl'

import App from './App.vue'
import '@/vendor/sensors'
import router from './router'
import store from './store'
import VueClipboard from 'vue-clipboard2'
import config from './config'
import vui from './components'
import '@/utils/filter'

Vue.config.productionTip = false

Vue.use(config)
Vue.use(iView)
Vue.use(vui)
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
// 注册一个全局自定义指令 `v-focus`
Vue.directive('focus', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el) {
    // 聚焦元素
    el.focus()
  },
})

document.addEventListener('visibilitychange', function () {
  if (!document.hidden) {
    if (store.state.app.isLogin && !localStorage.getItem('token')) {
      store.dispatch('app/quit')
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
